document.addEventListener('DOMContentLoaded', () => {
  const nav = document.getElementById('site-nav');
  const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const burger = document.getElementById('burger');
  const menu = document.getElementById('menu');
  const closeBtn = document.getElementById('menu-close');
  const openMenu = () => {
    menu.hidden = false;
    requestAnimationFrame(() => menu.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  };
  const closeMenu = () => {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => (menu.hidden = true), 500);
  };
  burger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeMenu));

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  if (hasGsap && !reduced) {
    document.documentElement.classList.add('is-motion');
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    const T = { womb: '#050505', light: '#F1EEE7', acid: '#D7FF2F', violet: '#28143D' };
    // A .rv block is hidden by CSS until JS runs; show() lifts that so its children can be sequenced instead.
    const show = (el) => { el.style.opacity = '1'; el.style.transform = 'none'; };
    const pick = (el, sel) => (el.matches(sel) ? [el] : Array.from(el.querySelectorAll(sel)));
    const px = (el, prop) => { const v = parseFloat(getComputedStyle(el)[prop]); return Number.isFinite(v) ? v : 0; };
    // Wraps each word of the text nodes in a span; element children (the quote's accent) stay one unit.
    const splitWords = (el) => {
      const out = [];
      Array.from(el.childNodes).forEach((node) => {
        if (node.nodeType === 1) { if (node.textContent.trim()) { node.classList.add('rv-w'); out.push(node); } return; }
        if (node.nodeType !== 3) return;
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
          const s = document.createElement('span');
          s.className = 'rv-w';
          s.textContent = part;
          frag.appendChild(s);
          out.push(s);
        });
        node.replaceWith(frag);
      });
      return out;
    };

    // 1. Reveals by role: one ScrollTrigger per .rv block, children sequenced by what they are.
    const ROLE = {
      k: '.kicker, .acc__grouptitle, .quote__attr, .hero__brand',
      t: '.display, .headline, .hero__line',
      b: 'p.body-copy, .body-copy > p, .body-copy > ul, .hero__sub',
      a: '.arrowlink',
      w: '.quote__text',
    };
    const ANY = Object.values(ROLE).join(', ');
    document.querySelectorAll('.rv').forEach((el) => {
      if (el.closest('[data-scene]')) { show(el); return; }
      const k = pick(el, ROLE.k), t = pick(el, ROLE.t), b = pick(el, ROLE.b), a = pick(el, ROLE.a);
      const w = pick(el, ROLE.w).flatMap(splitWords);
      const rest = Array.from(el.children).filter((c) => !c.matches(ANY) && !c.querySelector(ANY) && !w.includes(c));
      // The hero is always above the fold, so reveal it on load. Its text can sit below the
      // 'top 78%' line, which would otherwise leave it invisible until the visitor scrolls.
      const st = el.closest('.hero') ? undefined : { trigger: el, start: 'top 78%' }; // no once: a once-timeline killed mid-refresh broke every ScrollTrigger on deep reloads (2026-10-08)
      const tl = gsap.timeline({ delay: parseFloat(el.dataset.delay || 0), scrollTrigger: st, defaults: { ease: 'expo.out' } });
      if (!k.length && !t.length && !b.length && !a.length && !w.length) {
        tl.fromTo(el, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' });
        return;
      }
      show(el);
      const kAt = w.length ? w.length * 0.05 + 0.2 : 0;
      k.forEach((n) => {
        const ls = px(n, 'letterSpacing'), h0 = n.offsetHeight;
        gsap.set(n, { opacity: 0, letterSpacing: ls * 1.6 });
        if (n.offsetHeight !== h0) gsap.set(n, { letterSpacing: ls });   // the wider spacing would wrap it: fade only
        tl.to(n, { opacity: 1, letterSpacing: ls, duration: 0.9, clearProps: 'letterSpacing' }, kAt);
      });
      if (t.length) {
        gsap.set(t, { clipPath: 'inset(-10% 0 110% 0)', y: 16, willChange: 'clip-path, transform' });
        tl.to(t, { clipPath: 'inset(-10% 0 -10% 0)', y: 0, duration: 1, clearProps: 'clipPath,willChange' }, 0.1);
      }
      if (w.length) {
        gsap.set(w, { opacity: 0.08, y: 8 });
        tl.to(w, { opacity: 1, y: 0, duration: 0.9, stagger: 0.05, ease: 'power3.out' }, 0);
      }
      if (b.length) {
        gsap.set(b, { opacity: 0, filter: 'blur(6px)', willChange: 'filter, opacity' });
        tl.to(b, { opacity: 1, filter: 'blur(0px)', duration: 0.9, stagger: 0.08, ease: 'power3.out', clearProps: 'filter,willChange' }, 0.35);
      }
      if (rest.length) {
        gsap.set(rest, { opacity: 0 });
        tl.to(rest, { opacity: 1, duration: 0.9, ease: 'power2.out' }, 0.2);
      }
      a.forEach((n) => {
        const span = n.querySelector('span'), em = n.querySelector('em');
        if (span) { gsap.set(span, { clipPath: 'inset(-20% 100% -20% 0)' }); tl.to(span, { clipPath: 'inset(-20% 0% -20% 0)', duration: 0.6, clearProps: 'clipPath' }, 0.55); }
        if (em) { gsap.set(em, { opacity: 0 }); tl.to(em, { opacity: 1, duration: 0.4 }, 0.8); }
      });
    });

    // 2. Hero curtain: the poster stays put (CSS sticky); its scrim darkens as the next section covers it.
    const heroWrap = document.querySelector('main > .shopify-section:has(> .hero)');
    const scrim = heroWrap && heroWrap.querySelector('.hero__scrim');
    if (scrim && heroWrap.nextElementSibling) {
      gsap.to(scrim, { backgroundColor: 'rgba(5,5,5,.85)', ease: 'none',
        scrollTrigger: { trigger: heroWrap.nextElementSibling, start: 'top bottom', end: 'top top', scrub: true } });
    }

    // 3. The founder's picture blocks: settle, and light up as they enter. No permanent crop.
    document.querySelectorAll('.shopify-section [class^="ai-picture-placeholder-"]:not([class*="__"]) img').forEach((img) => {
      // Founder request 2026-09-28: the blue meditation picture (above the quote) stays still.
      if (img.closest('[id$="__178903785722d42603"]')) return;
      const frame = img.parentElement;
      gsap.fromTo(img, { scale: 1.06 }, { scale: 1, duration: 1.6, ease: 'power3.out',
        scrollTrigger: { trigger: frame, start: 'top 85%', once: true } });
      gsap.fromTo(img, { filter: 'brightness(.45)' }, { filter: 'brightness(1)', ease: 'none',
        scrollTrigger: { trigger: frame, start: 'top 95%', end: 'top 45%', scrub: true } });
    });

    // 4. Marquee: GSAP drives the drift so its speed can follow the scroll velocity; sleeps off screen.
    document.querySelectorAll('.marquee__track').forEach((track) => {
      track.style.animation = 'none';
      const drift = gsap.fromTo(track, { xPercent: 0 }, { xPercent: -50, duration: 28, ease: 'none', repeat: -1 });
      ScrollTrigger.create({ trigger: track.closest('.marquee'), start: 'top bottom', end: 'bottom top',
        onToggle: (s) => drift.paused(!s.isActive) });
      ScrollTrigger.create({ onUpdate: (s) => {
        drift.timeScale(Math.max(drift.timeScale(), gsap.utils.clamp(1, 3, 1 + Math.abs(s.getVelocity()) / 1500)));
        gsap.to(drift, { timeScale: 1, duration: 0.8, ease: 'power2.out', overwrite: true });
      } });
    });

    // 5. Quote: the candle glow breathes while the quote is on screen.
    document.querySelectorAll('.quote__bg img').forEach((bg) => {
      const breathe = gsap.to(bg, { scale: 1.06, duration: 9, ease: 'sine.inOut', yoyo: true, repeat: -1, paused: true });
      ScrollTrigger.create({ trigger: bg.closest('.quote'), start: 'top bottom', end: 'bottom top',
        onToggle: (s) => breathe.paused(!s.isActive) });
    });

    // 6. Accordion: native <details>, height tweened. paddingBottom rides along (border-box would clamp at 28px).
    document.querySelectorAll('.acc details').forEach((d) => {
      const a = d.querySelector('.acc__a'), sum = d.querySelector('summary');
      if (!a || !sum) return;
      sum.addEventListener('click', (e) => {
        e.preventDefault();
        a.style.overflow = 'hidden';
        if (d.open) {
          d.classList.add('is-closing');
          gsap.to(a, { height: 0, paddingBottom: 0, opacity: 0, duration: 0.35, ease: 'power2.in', overwrite: true,
            onComplete: () => { d.open = false; d.classList.remove('is-closing'); gsap.set(a, { clearProps: 'all' }); ScrollTrigger.refresh(); } });
        } else {
          d.open = true;
          gsap.from(a, { height: 0, paddingBottom: 0, opacity: 0, duration: 0.5, ease: 'power3.out', overwrite: true,
            clearProps: 'all', onComplete: () => ScrollTrigger.refresh() });
        }
      });
    });

    // 7. Pinned scenes, opt-in per section (data-scene). Pin length in px so the svh timing never bites.
    document.querySelectorAll('[data-scene]').forEach((sec) => {
      if (sec.dataset.scene === 'dawn') sec.classList.add('is-scene');
      const tl = gsap.timeline({ defaults: { ease: 'none', duration: 1 }, scrollTrigger: {
        trigger: sec, start: 'top top', end: () => '+=' + Math.round(window.innerHeight * 0.8), pin: true, scrub: 1 } });
      if (sec.dataset.scene === 'dawn') {
        // The light band arrives dark and the light comes on; the end state is today's band.
        const kick = sec.querySelectorAll('.kicker'), title = sec.querySelector('.display, .headline');
        const body = sec.querySelectorAll('.body-copy > p:not([style])'), foot = sec.querySelectorAll('.body-copy > p[style]');
        gsap.set(sec, { backgroundColor: T.womb, color: T.light });
        gsap.set(kick, { color: T.acid });
        gsap.set(body, { color: 'rgba(241,238,231,.75)' });
        gsap.set(foot, { color: 'rgba(241,238,231,.55)' });
        if (title) gsap.set(title, { clipPath: 'inset(-10% 0 110% 0)', y: 16 });
        tl.to(sec, { backgroundColor: T.light, color: T.womb }, 0)
          .to(kick, { color: T.violet }, 0)
          .to(body, { color: 'rgba(5,5,5,.75)' }, 0)
          .to(foot, { color: 'rgba(5,5,5,.55)' }, 0);
        if (title) tl.to(title, { clipPath: 'inset(-10% 0 -10% 0)', y: 0, duration: 0.4, ease: 'power2.out' }, 0);
      }
      if (sec.dataset.scene === 'lights-off') {
        // The violet band goes dark; the link is the only light left in the room.
        const panel = sec.querySelector('.split__panel'), link = sec.querySelector('.arrowlink');
        const copy = sec.querySelectorAll('.kicker, .display, .body-copy > p');
        if (panel) tl.to(panel, { backgroundColor: T.womb }, 0);
        tl.to(copy, { opacity: 0.35, duration: 0.7 }, 0.15);
        if (link) { gsap.set(link, { '--glow': 0 }); tl.to(link, { color: T.acid, '--glow': 1, duration: 0.5 }, 0.5); }
      }
    });

    document.querySelectorAll('[data-parallax] img').forEach((img) => {
      gsap.fromTo(img, { yPercent: -5 }, {
        yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: img.closest('[data-parallax]'), start: 'top bottom', end: 'bottom top', scrub: 1 },
      });
    });

    document.querySelectorAll('[data-settle] img').forEach((img) => {
      gsap.fromTo(img, { scale: 1.08 }, {
        scale: 1, duration: 1.6, ease: 'power2.out',
        scrollTrigger: { trigger: img.closest('[data-settle]'), start: 'top 82%', once: true },
      });
    });

    document.querySelectorAll('[data-kenburns] img').forEach((img) => {
      gsap.fromTo(img, { scale: 1 }, { scale: 1.07, duration: 20, ease: 'none', yoyo: true, repeat: -1 });
    });

    document.querySelectorAll('.menu__links a').forEach((a, i) => {
      gsap.fromTo(a, { opacity: 0, y: 24 }, {
        opacity: 1, y: 0, duration: 0.8, delay: 0.15 + i * 0.04, ease: 'power2.out', paused: false,
      });
    });

    const refresh = () => ScrollTrigger.refresh();
    window.addEventListener('load', refresh, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    document.addEventListener('shopify:section:unload', () => {
      ScrollTrigger.getAll().forEach((t) => { if (t.trigger && !document.contains(t.trigger)) t.kill(true); });
    });
  } else {
    document.querySelectorAll('.rv').forEach((el) => el.classList.add('is-in'));
  }

  // Smoothness (2026-10-14): a section off screen gets .perf-off, which pauses its infinite CSS animations (theme.css).
  // Sections holding a <dialog> are skipped: the pop-up section is 0px tall but its dialog shows over everything.
  // A very tall section (the event page is a single ~17,000px section) sleeps block by block instead.
  if ('IntersectionObserver' in window) {
    const sleep = new IntersectionObserver((entries) => entries.forEach((e) => e.target.classList.toggle('perf-off', !e.isIntersecting)), { rootMargin: '150px 0px' });
    const watch = (el) => { if (!el.querySelector('dialog')) sleep.observe(el); };
    document.querySelectorAll('main > .shopify-section').forEach((sec) => {
      const tall = sec.offsetHeight > 3 * innerHeight && [...sec.children].find((c) => c.offsetHeight > 3 * innerHeight);
      if (tall) [...tall.children].forEach((el) => { if (el.offsetHeight) watch(el); }); else watch(sec);
    });
  }

  document.querySelectorAll('form[data-store]').forEach((form) => {
    form.addEventListener('submit', () => {
      setTimeout(() => {
        const ok = form.querySelector('.formsuccess');
        if (ok) ok.hidden = false;
      }, 400);
    });
  });
});
